export enum CashTransferCompletionEnum {
  manualCompletion = 'manualCompletion',
  manualReversal = 'manualReversal'
}

export type TransferCashManualCompletionRequest = {
  completionType: CashTransferCompletionEnum;
  tracerId?: string;
};
